<section class="fullWidthCls admPageSec marginAtTop">
  <div class="container-fluid">
    <div class="row">
      <div class="admPageTitleSec">
        <p class="admPageTitle">
          <!-- <i class="material-icons cusIconSize">&#xE8B4;</i> -->
          <img src="./assets/images/Proctoring-Management_Icon.png" alt="" />
          <span>Search Proctor</span>
        </p>
      </div>
      <md-card>
        <md-card-header>
          <div class="admPageHeadingSec">
            <md-card-title>
              <div class="admPageHeading">
                <p>
                  <span>Search Proctor</span>
                </p>
              </div>
            </md-card-title>
          </div>
        </md-card-header>
        <md-card-content>
          <form class="example-form" [formGroup]="form">
            <div class="col s12 m4 l4">
              <md-form-field class="example-full-width">
                <input type="text" placeholder="Name" mdInput formControlName="name" [mdAutocomplete]="searchName">
                <md-autocomplete #searchName="mdAutocomplete">
                  <md-option *ngFor="let option of nameFilteredOptions" [value]="option.showStr">
                    {{ option.showStr }}
                  </md-option>
                </md-autocomplete>
              </md-form-field>
            </div>

            <div class="col s12 m4 l4">
              <md-form-field class="example-full-width">
                <input type="text" placeholder="Office" mdInput formControlName="office" [mdAutocomplete]="office" [showDropDown]="{model: 'office', scope : this }">
                <md-autocomplete #office="mdAutocomplete" [displayWith]="_utility.displayFn">
                  <md-option *ngFor="let option of officeFilteredOptions | async" [value]="option">
                    {{ option.name }}
                  </md-option>
                </md-autocomplete>
              </md-form-field>
            </div>

            <div class="col s12 m4 l4">
              <md-select placeholder="Group" formControlName="group" multiple>
                <md-option *ngFor="let option of groupOptions" [value]="option">
                  {{ option.groupCode }}
                </md-option>
              </md-select>
            </div>

            <div class="col s12 m4 l4" *ngIf="showField">
              <md-select placeholder="Proctor Lead" formControlName="proctorLead">
                <md-option>Select</md-option>
                <md-option *ngFor="let option of proctorLeadOptions" [value]="option">
                  {{ option.text }}
                </md-option>
              </md-select>
            </div>
          </form>

        </md-card-content>
        <md-card-actions>
          <div class="button-row">
            <button [disabled]="isSearchDisable" md-raised-button class="glbAdminBtnCls1" (click)="onSearch()">
              <i class="material-icons">&#xE8B6;</i>SEARCH</button>
            <button [disabled]="false" md-raised-button class="glbAdminBtnCls1" (click)="onManageClick(0)">
              <i class="material-icons">&#xE145;</i>ADD PROCTOR</button>
          </div>
        </md-card-actions>

      </md-card>
      <div class="button-row conflict-row">
        <h6>Proctor List</h6>
      </div>
      <!-- grid code -->
      <div class="cusPaginationContainer example-container mat-elevation-z8" *ngIf="paginationInfo && paginationInfo.totalRecords == 0">
        <p class="nodataFound"> No Results Found</p>
      </div>
      <div class="cusPaginationContainer example-container mat-elevation-z8" [ngClass]="{'hide-grid':paginationInfo && paginationInfo.totalRecords == 0 }">
        <md-table #table [dataSource]="dataSource" mdSort>

          <md-header-row *mdHeaderRowDef="displayedColumns"></md-header-row>
          <md-row *mdRowDef="let row; columns: displayedColumns;"></md-row>

          <ng-container mdColumnDef="firstName">
            <md-header-cell *mdHeaderCellDef md-sort-header>PROCTOR NAME</md-header-cell>
            <md-cell *mdCellDef="let element"> {{element.firstName + " " + element.lastName}} </md-cell>
          </ng-container>

          <ng-container mdColumnDef="userEmail">
            <md-header-cell *mdHeaderCellDef md-sort-header> EMAIL </md-header-cell>
            <md-cell *mdCellDef="let element"> {{element.userEmail}} </md-cell>
          </ng-container>

          <ng-container mdColumnDef="officeName">
            <md-header-cell *mdHeaderCellDef md-sort-header> OFFICE </md-header-cell>
            <md-cell *mdCellDef="let element"> {{element.officeName}} </md-cell>
          </ng-container>

          <ng-container mdColumnDef="contactNumber">
            <md-header-cell *mdHeaderCellDef md-sort-header>CONTACT NUMBER</md-header-cell>
            <md-cell *mdCellDef="let element"> {{element.contactNumber}} </md-cell>
          </ng-container>

          <ng-container mdColumnDef="groupName">
            <md-header-cell *mdHeaderCellDef md-sort-header> GROUP</md-header-cell>
            <md-cell *mdCellDef="let element"> {{element.groupName}} </md-cell>
          </ng-container>

          <!-- Satus Column -->
          <ng-container mdColumnDef="isDeleted">
            <md-header-cell *mdHeaderCellDef md-sort-header> STATUS </md-header-cell>
            <md-cell *mdCellDef="let element">
              <span [ngClass]="getStatusCls(element.isDeleted)"></span> {{element.isDeleted == 1?'Retired':'Active'}} </md-cell>
          </ng-container>

          <!-- Action Column -->
          <ng-container mdColumnDef="Action">
            <md-header-cell *mdHeaderCellDef>ACTIONS</md-header-cell>
            <md-cell *mdCellDef="let element">
              <a href="javascript:void(0);" (click)="onManageClick(element.id)">Manage</a>
            </md-cell>
          </ng-container>
        </md-table>
        <md-paginator #paginator [length]="paginationInfo.totalRecords" [pageIndex]="0" [pageSize]="dataSource.initialPageSize" [pageSizeOptions]="dataSource.pageSizeOptions"
          (page)="dataSource.onPaginateChange(appUrl.getProctorDetail,$event,this,remotePaginationParams)">
        </md-paginator>
      </div>

      <!-- grid code end -->

    </div>
  </div>
</section>


// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Components/adm-manage-proctor-team-lead/adm-manage-proctor-team-lead.component.html